import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) =>
        Api.fetchVacation(payload.vacationId, payload.childId)
            .flatMap(response => {
                if (response && response.ownReplies && response.ownReplies.length) {
                    return [Actions.fetchSuccess.action(response.vacation, response.ownReplies, response.openingHours)];
                } else {
                    return [
                        GlobalEventActions.updateError.action(i18next.t('childProfile.rsvpDeleted')),
                        Actions.fetchAborted.action(),
                    ];
                }
            })
            .catch(e => Observable.of(Actions.fetchFailed.action(e))),
    );

const update = action$ =>
    action$.ofType(Actions.update.type).mergeMap(({payload}) => {
        const requests = payload.dayMaps.map((days, childId) => {
            return Api.updateReplyForChild(payload.vacationId, childId, days.toJS());
        });
        return Observable.zip(...requests.valueSeq().toArray())
            .flatMap(() => [
                Actions.updateSuccess.action(payload.dayMaps.keySeq().toArray(), payload.vacationId),
                GlobalEventActions.updateSuccess.action(i18next.t('childProfile.answerSubmitted')),
            ])
            .catch(e => Observable.of(Actions.updateFailed.action(e)));
    });

export default combineEpics(fetch, update);
